export enum UPDATE_IMPORT_ACTIONS {
    START = 'start',
    CANCEL = 'cancel',
    CANCEL_ALL = 'cancel_all',
}
